import { Skeleton } from '@shared/components/shadcn';
import { GraphicContainer } from '../../../GraphicContainer/GraphicContainer';

function OfferLoading() {
  return (
    <div className="ll-grid-container min-h-[calc(100vh-100px)] md:min-h-0">
      <div className="ll-container-full">
        <GraphicContainer className="h-44 animate-pulse bg-gray-200" />
      </div>

      <div className="ll-container-inner flex flex-col my-4">
        <Skeleton className="h-6 w-32 rounded-md" />
        <Skeleton className="h-8 w-3/4 mb-2 mt-5" />
      </div>

      <div className="ll-container-inner space-y-6 mb-8">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="flex gap-4">
            <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
            <div className="flex-1 space-y-2">
              <Skeleton className="h-6 w-2/3" />
            </div>
          </div>
        ))}
      </div>

      <div className="ll-container-inner space-y-4">
        <Skeleton className="h-7 w-48" />
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
        </div>
      </div>
    </div>
  );
}

export { OfferLoading };
